import { Api } from "../config/request";

const base_url = "/catalyst/fleet-coach-app-release";

export default {
  getFleetCoachAppReleasesList(body) {
    return Api.post(`${base_url}/list`, body);
  },

  getApkUploadUrl(version) {
    return Api.get(`${base_url}/apk_presigned_url?app_version=${version}`);
  },

  getApkDownloadUrl(id) {
    return Api.get(`${base_url}/${id}/download`);
  },

  createAppRelease(body) {
    return Api.post(`${base_url}/create`, body);
  },

  editAppRelease(id, body) {
    return Api.put(`${base_url}/${id}/edit`, body);
  },

  launchAppRelease(id, body) {
    return Api.post(`${base_url}/${id}/launch`, body);
  },
};
